export default __webpack_public_path__ + "static/assets/6adb9b968cd1c25cad10a4ef560dc2e7.png";